import publicDashboard, { PublicDashboardStore } from './publicDashboardReducer';
import publicDeviceData, { PublicDeviceDataStore } from './publicDeviceSagas/PublicDeviceDataReducer';
import publicDeviceSensorData, { PublicDeviceSensorDataStore } from './publicDeviceSagas/PublicDeviceSensorDataReducer';
import publicUserPreferences, { PublicUserPreferencesStore } from './publicUserPreferences';
import radonDataReducer from './radonReducer';
import publicRequests, { PublicRequestStore } from './requestReducer';

export interface Store {
    publicDeviceData: PublicDeviceDataStore;
    publicDeviceSensorData: PublicDeviceSensorDataStore;
    publicDashboard: PublicDashboardStore;
    publicRequests: PublicRequestStore;
    publicUserPreferences: PublicUserPreferencesStore;
}

const rootReducer = {
    publicDeviceData,
    publicDeviceSensorData,
    radonDataReducer,
    publicDashboard,
    publicRequests,
    publicUserPreferences,
};

export default rootReducer;
